import lowerCase from 'lodash/lowerCase';

export default {
    data: () => ({
        /*app: window.App || {}*/
    }),

    computed: {
        app() {
            return window.App || {};
        },

        appName() {
            return this.app.name || 'NamePromo';
        },

        appUrl() {
            return this.app.url || '';
        },

        user() {
            return this.app.user || null;
        },

        guest() {
            return !this.user;
        },

        isAdminUser() {
            return this.user && this.user.admin;
        }
    },

    methods: {
        /**
         * @todo should action be lowercased?
         */
        trackEvent(category, action, label, value) {
            this.trackRawEvent(action, {
                'event_category' : lowerCase(category),
                'event_label'    : label,
                'value'          : value
            });
        },

        /**
         * @see https://support.google.com/google-ads/answer/7548399
         * @see https://developers.google.com/gtagjs/reference/event
         * @see https://developers.google.com/gtagjs/reference/parameter
         * @see https://developers.google.com/analytics/devguides/collection/gtagjs/events
         */
        trackRawEvent(name, params) {
            if (typeof gtag === 'undefined') {
                return;
            }

            var data = params;
            data.send_to = process.env.MIX_GOOGLE_ANALYTICS_ID;

            gtag('event', name, data);
        }
    }
};
